import { app } from '../../../app';

class SmsServices {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    smsUsageReport(companyId, periodFilter, startDate, endDate) {
        const url = `app/rest/company/${companyId}/smsUsageReport`;
        const params = {periodFilter, startDate, endDate};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    purchaseHistory(companyId) {
        const url = `app/rest/company/${companyId}/purchaseHistory`;
        return this.$http.get(url).then(({data}) => data);
    }

    invoice(companyId, token) {
        const url = `app/rest/company/${companyId}/invoice`;
        const params = {token};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    setupExpressCheckout(companyId, packageType) {
        const url = `app/rest/company/${companyId}/setupExpressCheckout`;
        const params = {packageType};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    expressCheckoutDetails(companyId, token) {
        const url = `app/rest/company/${companyId}/expressCheckoutDetails`;
        const params = {token};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    finalizeCheckoutPayment(companyId, token, status) {
        const url = `app/rest/company/${companyId}/finalizeCheckoutPayment`;
        const params = {token, status};
        return this.$http.get(url, {params}).then(({data}) => data);
    }
}

app.service('SmsServices', SmsServices);



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-services.service.js